// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.perxis-auto-1_16_0-color-picker {
  /* Border */
  --perxis-auto-color-picker-border-radius-inner: var(--perxis-auto-color-picker-border-radius, 50%);
  /* End Border */
  /* Colors */
  --perxis-auto-color-picker-icon-first-color-inner: var(--perxis-auto-color-picker-icon-first-color, var(--perxis-auto-root-first-color-inner));
  --perxis-auto-color-picker-icon-second-color-inner: var(--perxis-auto-color-picker-icon-second-color, var(--perxis-auto-root-second-color-inner));
  /* End Colors */
}
.perxis-auto-1_16_0-color-picker .perxis-auto-1_16_0-checkbox {
  --perxis-auto-checkbox-border-radius: var(--perxis-auto-color-picker-border-radius-inner);
  --perxis-auto-checkbox-hover-opacity: 1;
  --perxis-auto-checkbox-checked-background-color: var(--perxis-auto-checkbox-third-color);
}
.perxis-auto-1_16_0-color-picker .ant-5_17_0-checkbox-wrapper .ant-5_17_0-checkbox.ant-5_17_0-checkbox-disabled span.ant-5_17_0-checkbox-inner {
  background-color: var(--perxis-auto-checkbox-first-color-inner);
  border-color: var(--perxis-auto-checkbox-third-color-inner);
}
.perxis-auto-1_16_0-color-picker .ant-5_17_0-checkbox-wrapper.perxis-auto-1_16_0-color-picker__item--border-contrast .ant-5_17_0-checkbox .ant-5_17_0-checkbox-inner, .perxis-auto-1_16_0-color-picker .ant-5_17_0-checkbox-wrapper.perxis-auto-1_16_0-color-picker__item--border-contrast .ant-5_17_0-checkbox.ant-5_17_0-checkbox-checked .ant-5_17_0-checkbox-inner {
  border-color: var(--perxis-auto-checkbox-fourth-color-inner) !important;
}
.perxis-auto-1_16_0-color-picker .ant-5_17_0-checkbox-wrapper.perxis-auto-1_16_0-color-picker__item--border-colored .ant-5_17_0-checkbox:not(.ant-5_17_0-checkbox-disabled) .ant-5_17_0-checkbox-inner, .perxis-auto-1_16_0-color-picker .ant-5_17_0-checkbox-wrapper.perxis-auto-1_16_0-color-picker__item--border-colored .ant-5_17_0-checkbox.ant-5_17_0-checkbox-checked:not(.ant-5_17_0-checkbox-disabled) .ant-5_17_0-checkbox-inner {
  border-color: var(--perxis-auto-checkbox-third-color-inner) !important;
}
.perxis-auto-1_16_0-color-picker .ant-5_17_0-checkbox-wrapper.perxis-auto-1_16_0-color-picker__item--check-light .ant-5_17_0-checkbox-checked:not(.ant-5_17_0-checkbox-indeterminate) .ant-5_17_0-checkbox-inner::after {
  color: var(--perxis-auto-color-picker-icon-first-color-inner);
}
.perxis-auto-1_16_0-color-picker .ant-5_17_0-checkbox-wrapper.perxis-auto-1_16_0-color-picker__item--check-dark .ant-5_17_0-checkbox-checked:not(.ant-5_17_0-checkbox-indeterminate) .ant-5_17_0-checkbox-inner::after {
  color: var(--perxis-auto-color-picker-icon-second-color-inner);
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
